// Modules
import * as wizard from './wizard';

import {
  getLayerByFeature, getLayerByPlanId, highlightPlanId, map,
  removePlanId, setPlanIdOpacity, setPlanIdTitle, togglePlanId,
  zoomToLayer
} from './map/tools';
import { getPlanIdFormål } from './map/feature-tools';
import { getLayerById, highlightLayer } from './map/layer-tools';
import { idb } from './map/storage';
import { createNavigationTo, createSlider } from './util';

const list = document.getElementById('listOfLayers');

export const addToPlanIdList = (plan, layer, list) => {
  const planid = plan.planid;
  const drawn = plan.drawn;
  const fn = ['Fremtidig', 'Nåværende'].indexOf(plan.objtype) > -1;
  const checked = plan.checked ?? (drawn ? true : false);
  const item = document.createElement('li');
  const formål = getPlanIdFormål(layer, planid);
  const disabled = !formål && !drawn && !fn;
  if (disabled) {
    item.className = 'disabled';
    item.title = 'PlanId som ikke blir med i beregning, fordi mangler formål';
  }
  const left = document.createElement('span');
  left.className = 'left-elements';
  const fitBtn = createNavigationTo(planid, layer);
  const cb = document.createElement('input');
  cb.type = 'checkbox';
  cb.title = 'Velg';
  cb.id = planid;
  cb.name = planid;
  cb.value = planid;
  cb.checked = checked;
  if (disabled) cb.disabled = true;
  cb.onchange = () => togglePlanId(layer, planid, cb.checked);
  const label = document.createElement('label');
  label.htmlFor = planid;
  // label.innerHTML = planid;
  // label.contentEditable = true;
  const textField = document.createElement('input');
  textField.type = 'text';
  textField.title = 'Rediger navn';
  textField.name = 'planid'; // egenskap name er anbefalt på form-elementer
  textField.value = plan.title || planid;
  // textField.size = planid.length / 2;
  textField.className = 'planid-list-item';
  textField.onchange = (c) => setPlanIdTitle(layer, planid, c.target.value);
  label.appendChild(textField);

  const adapting = document.createElement('span');
  adapting.className = 'adapting-width';
  const slider = createSlider();
  slider.value = plan.opacity ?? 100;
  slider.oninput = () => setPlanIdOpacity(layer, planid, slider.value);
  slider.onchange = () => idb.updateLayer(layer);

  const deleteBtn = document.createElement('button');
  deleteBtn.type = 'button';
  deleteBtn.className = 'custom-btn x-btn red-transition';
  deleteBtn.setAttribute('ariaLabel', 'Slett');
  deleteBtn.title = 'Slett';
  deleteBtn.innerHTML = '<span aria-hidden="true">&times;</span>';
  deleteBtn.onclick = () => {
    list.removeChild(item); // removeFeatureItemFromLayerList // item.remove();
    removePlanId(layer, planid); // removeFeaturesBelongingToPlanIdFromLayer;
    //if (!list.hasChildNodes()) { // does not work until velg planid is present
    if (layer.getSource().getFeatures().length < 1) {
      // console.log('empty layer', layer.getProperties());
      list.parentElement.querySelector('.rmv-geo').click();
    }
  };

  left.appendChild(fitBtn);
  left.appendChild(cb);
  left.appendChild(label);
  left.appendChild(deleteBtn);
  item.appendChild(left);
  adapting.appendChild(slider);
  item.appendChild(adapting);
  item.onmouseenter = () => highlightPlanId(planid, true, layer);
  item.onmouseleave = () => highlightPlanId(planid, false, layer);
  list.appendChild(item);
};

const makePlanIdList = (layer) => {
  const list = document.createElement('ul');
  // list.hidden = true;
  list.className = 'planid-list';
  const planids = [];
  const info = {};
  layer.getSource().getFeatures().forEach(feature => {
    const p = feature.getProperties();
    if (!p.suitable) return;
    p.checked ?? feature.set('checked', false);
    if (planids.indexOf(p.planid) > -1) return;
    planids.push(p.planid);
    info[p.planid] = p;
  });
  if (planids.length > 0) {
    const item = document.createElement('li');
    item.innerHTML = '&nbsp;Velg planid:';
    list.appendChild(item);
  }
  planids.sort().forEach(planid => addToPlanIdList(info[planid], layer, list));
  return list;
};

const togglePlanIdList = (planIdList, checked) => {
  const plan = planIdList.children;
  const l = plan.length;
  for (let i = 0; i < l; i++) {
    const cb = plan[i].querySelector('input[type="checkbox"]');
    if (cb && !cb.disabled && cb.checked !== checked) {
      cb.checked = checked;
      cb.dispatchEvent(new Event('change'));
    }
  }
};

export const addLayerToList = (layer) => {
  const item = document.createElement('li');
  // f.setId(f.ol_uid); // VectorSource#getFeatureById
  item.id = layer.get('type') + layer.ol_uid; // file name might not be unique
  // console.log('id:',  item.id);
  const cb = document.createElement('input');
  const plus = document.createElement('b');
  const textField = document.createElement('input');
  const fitBtn = document.createElement('button');
  const deleteBtn = document.createElement('button');
  const planIdList = makePlanIdList(layer);
  cb.type = 'checkbox';
  cb.title = 'Velg alle';
  cb.name = 'alle'; // egenskap name er anbefalt på form-elementer
  cb.checked = false; // unchecked list
  cb.onchange = () => togglePlanIdList(planIdList, cb.checked);
  plus.className = 'pointer';
  plus.innerHTML = '‒ ';
  plus.title = 'Sammentrekk';
  plus.onclick = () => {
    planIdList.hidden = !planIdList.hidden;
    plus.innerHTML = planIdList.hidden ? '+ ' : '‒ ';
  };
  textField.type = 'text';
  textField.title = 'Rediger navn';
  textField.name = 'filnavn'; // egenskap name er anbefalt på form-elementer
  textField.value = layer.get('label') || layer.get('id');
  textField.defaultValue = textField.value;
  textField.onchange = (c) => layer.set('label', c.target.value);
  // textField.onmouseenter = () => layer.setStyle(highlightStyle);
  // textField.onmouseleave = () => layer.setStyle(originalStyle);
  textField.onmouseenter = () => highlightLayer(layer, true);
  textField.onmouseleave = () => highlightLayer(layer, false);
  fitBtn.type = 'button';
  fitBtn.className = 'custom-btn green-transition fit-geo';
  fitBtn.setAttribute('ariaLabel', 'Zoom');
  fitBtn.title = 'Zoom';
  // fitBtn.innerHTML = '<span aria-hidden="true">&#128270;</span>'; // magnify
  fitBtn.innerHTML = '<span aria-hidden="true">&#128065;</span>'; // eye
  // fitBtn.innerHTML = `
  //   <span aria-hidden="true">&#8689;</span>
  //   <span aria-hidden="true">&#8690;</span>
  // `; // fitting square
  fitBtn.onclick = () => zoomToLayer(layer);
  deleteBtn.type = 'button';
  deleteBtn.className = 'custom-btn x-btn red-transition rmv-geo';
  deleteBtn.setAttribute('ariaLabel', 'Slett');
  deleteBtn.title = 'Slett';
  deleteBtn.innerHTML = '<span aria-hidden="true">&times;</span>';
  deleteBtn.onclick = () => {
    list.removeChild(item); // removeLayerFromList
    if (layer.get('id') === 'drawings') layer.getSource().clear();
    if (layer.get('id') === 'drawings') idb.deleteLayer('drawings');
    else map.removeLayer(layer); // removeLayerFromMap;
    if (!list.hasChildNodes()) {
      document.getElementById('queryBtn').hidden = true;
      document.getElementById('saveGeometryBtn').hidden = true;
    }
    // Chrome fyrer ikke onchange når siste fil var lik:
    if (upload.files[0]?.name === textField.defaultValue) upload.value = null;
  };
  item.appendChild(plus);
  item.appendChild(fitBtn);
  item.appendChild(cb);
  item.appendChild(textField);
  item.appendChild(deleteBtn);
  item.appendChild(planIdList);
  list.appendChild(item);
  document.getElementById('queryBtn').hidden = false;
  // document.getElementById('saveGeometryBtn').hidden = false;
  return item;
};

export const getListItemByPlanId = (planId, layer) => {
  if (!layer) layer = getLayerByPlanId(planId);
  const li = getListItemFromLayer(layer);
  if (!li) return;
  const innerList = li.querySelector('ul.planid-list');
  const items = innerList.children;
  const len = items.length;
  for (let i = 0; i < len; i++) {
    const item = items[i];
    const cb = item.querySelector('input[type="checkbox"]');
    if (cb && cb.name === planId) return item;
  }
};

export const highlightCorrespondingListItem = (f) => {
  const layer = getLayerByFeature(f);
  const planid = f.get('planid');
  const li = getListItemByPlanId(planid);
  if (li) {
    const cl = li.classList;
    if (!cl.contains('highlightedItem')) removeListItemHighlight();
    cl.add('highlightedItem');
    li.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
};

export const removeListItemHighlight = () => {
  const toBeRemoved = list.querySelector('.highlightedItem');
  toBeRemoved?.classList.remove('highlightedItem');
};

export const getListItemFromLayer = (layer) => {
  const itemId = layer.get('type') + layer.ol_uid;
  return list.querySelector(`#${itemId}`);
};
